// Clinic catalog, availability and appointment requests (v1).
import api, {items} from './client';
import {toAppointment} from './AppointmentApi';

const slotParams = (params = {}) => {
  const q = new URLSearchParams({
    start: params.startDate || new Date().toISOString(),
    end: params.endDate || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
  });
  if (params.doctorId) q.set('doctor_id', params.doctorId);
  if (params.timezone) q.set('timezone', params.timezone);
  return q;
};

export const getClinics = () => api.get('/clinics?page_size=100').then((r) => items(r.data));

export const getDivisions = (clinicId) =>
  api.get(`/clinics/${encodeURIComponent(clinicId)}/divisions`).then((r) => r.data);

export const getDoctors = (divisionId) =>
  api
    .get(`/doctors?page_size=100${divisionId ? `&division_id=${divisionId}` : ''}`)
    .then((r) => items(r.data));

export const getClinicTimeSlots = (_clinicId, params = {}) =>
  api.get(`/availability?${slotParams(params)}`).then((r) => r.data);

export const getClinicDivisionTimeSlots = (_clinicId, divisionId, params = {}) => {
  const q = slotParams(params);
  q.set('division_id', divisionId);
  return api.get(`/availability?${q}`).then((r) => r.data);
};

export const getAppointmentRequests = (params = {}) => {
  const q = new URLSearchParams({page_size: '100'});
  if (params.status) q.set('status', params.status);
  if (params.doctorId) q.set('doctor_id', params.doctorId);
  return api.get(`/appointment-requests?${q}`).then((r) => items(r.data).map(toAppointment));
};

export const getAppointmentRequestById = (id) =>
  api.get(`/appointment-requests/${id}`).then((r) => toAppointment(r.data));

export const initiateAppointmentTransfer = (transferData) =>
  api
    .post(`/appointment-requests/${transferData.appointment_request_id}/transfer`, {
      new_doctor_id: transferData.new_doctor_id,
      transfer_reason: transferData.transfer_reason || '',
    })
    .then((r) => toAppointment(r.data));

export const confirmAppointmentTransfer = (appointmentId, confirmed) =>
  api
    .post(`/appointment-requests/${appointmentId}/transfer/decision`, {accept: Boolean(confirmed)})
    .then((r) => toAppointment(r.data));
